import React from 'react';
import './PromptPresets.css';

const PROMPT_PRESETS = [
  {
    category: 'Content Creation',
    prompts: [
      { text: 'Write landing page', prompt: 'Create a compelling landing page for a SaaS product. Include hero section, features, pricing, and CTA.' },
      { text: 'Generate blog post', prompt: 'Write a comprehensive blog post about [topic]. Include introduction, main points, and conclusion.' },
      { text: 'Create social media post', prompt: 'Create an engaging social media post for [platform] about [topic]. Include relevant hashtags.' },
    ],
  },
  {
    category: 'Image & Video',
    prompts: [
      { text: 'Edit image background', prompt: 'Remove the background from this image and replace it with [description].' },
      { text: 'Create video script', prompt: 'Write a video script for a [type] video about [topic]. Include hook, main content, and call-to-action.' },
      { text: 'Generate product image', prompt: 'Create a professional product image showing [product] with [features].' },
    ],
  },
  {
    category: 'Business & Strategy',
    prompts: [
      { text: 'Generate startup plan', prompt: 'Create a comprehensive startup plan for [business idea]. Include market analysis, business model, and go-to-market strategy.' },
      { text: 'Write business proposal', prompt: 'Draft a professional business proposal for [project/client]. Include executive summary, solution, and pricing.' },
      { text: 'Create marketing strategy', prompt: 'Develop a marketing strategy for [product/service]. Include target audience, channels, and tactics.' },
    ],
  },
  {
    category: 'Development',
    prompts: [
      { text: 'Write code function', prompt: 'Write a [language] function that [description]. Include error handling and comments.' },
      { text: 'Debug code issue', prompt: 'Help me debug this code: [paste code]. Identify the issue and provide a fix.' },
      { text: 'Create API documentation', prompt: 'Generate API documentation for [endpoint]. Include request/response examples and error codes.' },
    ],
  },
];

export default function PromptPresets({ onSelectPreset }) {
  return (
    <div className="prompt-presets">
      <div className="prompt-presets-header">
        <h3>💡 Quick Actions</h3>
        <p>Select a preset to get started quickly</p>
      </div>
      {PROMPT_PRESETS.map((category) => (
        <div key={category.category} className="preset-category">
          <h4 className="preset-category-title">{category.category}</h4>
          <div className="preset-buttons">
            {category.prompts.map((preset, index) => (
              <button
                key={index}
                className="preset-button"
                onClick={() => onSelectPreset(preset.prompt)}
              >
                {preset.text}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

